/** Reveal gameplay chrome after the server has accepted the player's login. */
export function revealGameplayHud(doc: Document = document): void {
  doc.body.classList.remove('prelogin');
}
